class DelayContent extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.delayAnimateEl = this.querySelectorAll(".delay-animate");
    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      { rootMargin: "0px", threshold: 0 }
    );
    this.observer.observe(this);
  }
  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.start();
        this.observer.unobserve(this);
      }
    });
  }
  start() {
    if (this.delayAnimateEl.length > 0) {
      this.delayAnimateEl.forEach((item, index) => {
        item.classList.add("is-loaded");
      });
    }
  }
}
customElements.define("delay-content", DelayContent);

class InfluencerVideoSlides extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.mediaElements = this.querySelectorAll('video');
      this.isMobile = window.innerWidth <= 768;

      this.initSwiper();
      this.mediaElements.forEach((media) => {
        if (this.isMobile) {
          media.addEventListener('click', () => this.togglePlay(media));
        } else {
          media.parentNode.addEventListener('mouseenter', () => this.playMedia(media));
          media.parentNode.addEventListener('mouseleave', () => this.pauseMedia(media));
        }
      });
      this.initMuteToggle();
      // this.initAddToCartTracking();
      // this.initViewTracking();
    }
    initSwiper() {
      const videos = this.querySelectorAll('video');
      const swiperContainer = this.querySelector(`#influencer-video-list-${this.sectionId}`);

      new Swiper(swiperContainer, {
        speed: 600,
        breakpoints: {
          320: { spaceBetween: 12, slidesPerView: 1.2, allowTouchMove: true },
          769: { spaceBetween: 16, slidesPerView: 4 },
        },
        navigation: {
          nextEl: '.influencer-video-slide-arrow-right',
          prevEl: '.influencer-video-slide-arrow-left',
        },
        on: {
          transitionEnd: (swiper) => {
            if (window.innerWidth <= 768) {
              const activeSlide = swiper.slides[swiper.activeIndex];
              if (activeSlide) {
                const video = activeSlide.querySelector('video');
                if (video) {
                  videos.forEach((v) => {
                    v.pause();
                    v.parentNode.classList.remove('play');
                  });
                  video.play();
                  video.parentNode.classList.add('play');
                }
              }
            }
          },
        },
      });
    }

    initMuteToggle() {
      const videos = this.querySelectorAll('video');
      const videosWrapper = document.querySelector(`#influencer-video-list-${this.sectionId}`);
      videosWrapper.addEventListener('click', (e) => {
        e.stopPropagation();
        const target = e.target;
        if (target && target.classList.contains('influencer-video-muted_icon')) {
          const index = target.dataset.index;
          if (videos[index]) {
            videos[index].muted = videos[index].muted ? false : true;
            target.dataset.muted = videos[index].muted ? 'true' : 'false';
          }
        }
      });
    }

    initAddToCartTracking() {
      // const section = document.querySelector(`#influencer-video-section-${this.sectionId}`);
      // const addButtons = section.querySelectorAll('.influencer-video-slide-product-add_button button[name="add"]');
      // if (addButtons.length > 0) {
      //     addButtons.forEach(button => {
      //         button.addEventListener('click', (event) => {
      //             gtag('event', 'module_add', {
      //                 module_title: `${event.target.dataset.productTitle}-${event.target.dataset.index}`,
      //                 module_type: 'kol_video_slider'
      //             });
      //         });
      //     });
      // }
    }

    initViewTracking() {
      // const section = document.querySelector(`#influencer-video-section-${this.sectionId}`);
      // const observer = new IntersectionObserver((entries) => {
      //     entries.forEach(entry => {
      //         if (entry.intersectionRatio > 0.5) {
      //             gtag('event', 'module_view', {
      //                 module_type: 'kol_video_slider'
      //             });
      //             observer.unobserve(section);
      //         }
      //     });
      // }, { threshold: [0.5] });
      // observer.observe(section);
    }

    playMedia(media) {
      if (media.tagName === 'VIDEO') {
        media.play();
        media.parentNode.classList.add('play');
      }
    }

    pauseMedia(media) {
      if (media.tagName === 'VIDEO') {
        media.pause();
        media.parentNode.classList.remove('play');
      }
    }

    togglePlay(media) {
      if (media.tagName === 'VIDEO') {
        if (!media.paused) {
          media.pause();
          media.parentNode.classList.remove('play');
        } else {
          this.mediaElements.forEach((m) => {
            if (m !== media && m.tagName === 'VIDEO') {
              m.pause();
              m.parentNode.classList.remove('play');
            }
          });
          media.play();
          media.parentNode.classList.add('play');
          // gtag('event', 'module_interact', {
          //     module_title: `${media.dataset.productTitle}-${media.dataset.index}`,
          //     module_type: 'kol_video_slider'
          // });
        }
      }
    }
  }

  customElements.define('influencer-video-slides', InfluencerVideoSlides);

class defaultSwitchComponent extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.defaultClassList = this.getAttribute("default-classlist")?.split(",");
    this.activeClassList = this.getAttribute("active-classlist")?.split(",");
    this.lastActiveIndex = 0;
    this.eventType = this.getAttribute("event-type") || "click";
    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      { rootMargin: "0px" }
    );
    this.observer.observe(this);
  }
  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.init();
        this.observer.unobserve(this);
      }
    });
  }
  init() {
    if (
      Array.isArray(this.defaultClassList) &&
      this.defaultClassList.length > 0
    ) {
      this.switchNodes = this.querySwitchNodes();
      this.switchNodes[0].forEach((item, index) => {
        item.addEventListener(this.eventType, () => {
          if (item.classList.contains(this.activeClassList[0])) {
            return;
          }
          this.switchChange(index);
        });
      });
    }
    if (this.getAttribute("action-button")) {
      this.actionButtons = this.querySelectorAll(
        `.${this.getAttribute("action-button")}`
      );
      this.actionButtons.forEach((item, index) => {
        item.addEventListener(this.eventType, () => {
          if (item.classList.contains("selected")) {
            return;
          }
          this.switchChange(index);
        });
      });
    }
  }
  querySwitchNodes() {
    let switchNodes = [];
    this.defaultClassList.forEach((className) =>
      switchNodes.push(this.querySelectorAll(`.${className}`))
    );
    return switchNodes;
  }
  switchChange(index) {
    const newActiveIndex = index;
    this.switchNodes.forEach((nodes, idx) => {
      const lastActiveNode = nodes[this.lastActiveIndex];
      if (lastActiveNode) {
        lastActiveNode.classList.remove(this.activeClassList[idx]);
      }
    });

    this.switchNodes.forEach((nodes, idx) => {
      const newActiveNode = nodes[newActiveIndex];
      if (newActiveNode) {
        newActiveNode.classList.add(this.activeClassList[idx]);
      }
    });
    this.lastActiveIndex = newActiveIndex;
  }
}
customElements.define("default-switch-component", defaultSwitchComponent);

class CountUpElement extends HTMLElement {
  constructor() {
    super();
    this.regex = /(\d+),(\d+)/g;
  }
  connectedCallback() {
    this.count = this.textContent;
    if (isNaN(parseInt(this.count))) {
      return;
    }
    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      { rootMargin: "0px" }
    );
    this.observer.observe(this);
  }
  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.start();
        this.observer.unobserve(this);
      }
    });
  }
  formatNumber(number) {
    const numStr = number.toFixed(0); // 将数字转换为不带小数的字符串
    const formattedNumber = numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return formattedNumber;
  }
  start() {
    const targetValue = parseInt(this.textContent.replace(/,/g, ""));
    this.animation(2000, 0, targetValue, (val) => {
      this.textContent = this.formatNumber(val);
    });
  }

  animation(duration, from, to, onProgress) {
    if (from === to) return;
    const start = Date.now();
    const step = (to - from) / 111;

    function _run() {
      const t = Date.now() - start;
      if (t >= duration) {
        onProgress(to);
        return;
      }

      const progress = t / duration;
      const rawValue = from + (to - from) * progress;
      const steppedValue = Math.round(rawValue / step) * step;

      onProgress(steppedValue);
      requestAnimationFrame(_run);
    }

    _run();
  }
}
customElements.define("custom-countup", CountUpElement);


class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();

    this.config = {
      moveTime: parseFloat(this.dataset.speed), // 100px going to move for
      space: 100, // 100px
    };

    this.promotion = this.querySelector('.promotion');

    this.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

    initWhenVisible(options) {
    const threshold = options.threshold ? options.threshold : 0;
  
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    }, {rootMargin: `0px 0px ${threshold}px 0px`});
  
    observer.observe(options.element);
  }

  init() {
    if (this.childElementCount === 1) {
      this.promotion.classList.add('promotion--animated');

      for (let index = 0; index < 10; index++) {
        this.clone = this.promotion.cloneNode(true);
        this.clone.setAttribute('aria-hidden', true);
        this.appendChild(this.clone);

        const imageWrapper = this.clone.querySelector('.media-wrapper');
        if (imageWrapper) {
          imageWrapper.classList.remove('loading');
        }
      }

      const animationTimeFrame = (this.promotion.clientWidth / this.config.space) * this.config.moveTime;
      this.style.setProperty('--duration', `${animationTimeFrame}s`);

      // pause when out of view
      const observer = new IntersectionObserver((entries, _observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.scrollingPlay();
          } else {
            this.scrollingPause();
          }
        });
      }, {rootMargin: '0px 0px 50px 0px'});

      observer.observe(this);
    }
  }

  scrollingPlay() {
    this.classList.remove('scrolling-promotion--paused');
  }

  scrollingPause() {
    this.classList.add('scrolling-promotion--paused');
  }
}
customElements.define('scrolling-promotion', ScrollingPromotion);

class SuitProductQuantity extends HTMLElement {
    constructor() {
        super();
        this.section = document.getElementById(`${this.dataset.sectionId}`)
        this.changeEvent = new Event('change', { bubbles: true });
        if (!this.section) return
        this.input = this.querySelector('input');
        this.input.addEventListener('change', this.onQuantityChanged.bind(this));
        this.querySelector('button[name=plus]')?.addEventListener('click', this.quantityPlus.bind(this));
        this.querySelector('button[name=minus]')?.addEventListener('click', this.quantityMinus.bind(this));
        this.relatedInputs = []
        this.dataset.relatedInput.split(',').forEach(iptClassname => {
          const inputItem=this.section.querySelector(iptClassname)
            if (inputItem) {
                this.relatedInputs.push(inputItem)
            }
        })
    }
    onQuantityChanged(event) {
        if (event.target && event.target.value) {
            this.relatedInputs.forEach(ipt => {
                ipt.value = event.target.value
            })
        }
    }
    quantityPlus() {
        this.input.stepUp()
        this.input.dispatchEvent(this.changeEvent);
    }
    quantityMinus() {
        this.input.stepDown()
        this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('suit-product-quantity', SuitProductQuantity);

if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      const timezone = this.dataset.timezone,
        date = this.dataset.date.split('-'),
        day = parseInt(date[0]),
        month = parseInt(date[1]),
        year = parseInt(date[2]);

      let time = this.dataset.time,
        tarhour, tarmin;

      if (time != null) {
        time = time.split(':');
        tarhour = parseInt(time[0]);
        tarmin = parseInt(time[1]);
      }

      // Set the date we're counting down to
      let date_string = month + '/' + day + '/' + year + ' ' + tarhour + ':' + tarmin + ' GMT' + timezone;
      // Time without timezone
      this.countDownDate = new Date(year, month - 1, day, tarhour, tarmin, 0, 0).getTime();

      // Time with timezone
      this.countDownDate = new Date(date_string).getTime();

    }

    convertDateForIos(date) {
      var arr = date.split(/[- :]/);
      date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
      return date;
    }
    connectedCallback() {
      let _this = this;
      const updateTime = function() {

        // Get todays date and time
        const now = new Date().getTime();

        // Find the distance between now an the count down date
        const distance = _this.countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (distance < 0) {
          _this.querySelector('.days .countdown-timer--column--number').innerHTML = 0;
          _this.querySelector('.hours .countdown-timer--column--number').innerHTML = 0;
          _this.querySelector('.minutes .countdown-timer--column--number').innerHTML = 0;
          _this.querySelector('.seconds .countdown-timer--column--number').innerHTML = 0;
        } else {
          requestAnimationFrame(updateTime);
          _this.querySelector('.days .countdown-timer--column--number').innerHTML = CountdownTimer.addZero(days);
          _this.querySelector('.hours .countdown-timer--column--number').innerHTML = CountdownTimer.addZero(hours);
          _this.querySelector('.minutes .countdown-timer--column--number').innerHTML = CountdownTimer.addZero(minutes);
          _this.querySelector('.seconds .countdown-timer--column--number').innerHTML = CountdownTimer.addZero(seconds);
        }


      };
      requestAnimationFrame(updateTime);
    }
    static addZero(x) {
      return (x < 10 && x >= 0) ? "0" + x : x;
    }
  }
  customElements.define('countdown-timer', CountdownTimer);
}

class customBuyButton extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.clickButton = this.querySelector(".custom-buy-button");
    if (this.getAttribute("disabled")) {
      return;
    }
    if (this.clickButton) {
      this.init();
    }
  }
  init() {
    this.clickButton.addEventListener("click", () => {
      this.buyButton = this.querySelector(
        ".shopify-payment-button__more-options"
      );
      if (this.buyButton) {
        this.buyButton.click();
        return;
      }
      this.buyButton2 = this.querySelector(".shopify-payment-button__button");
      if (this.buyButton2) {
        this.buyButton2.click();
        return;
      }
      this.form = this.querySelector("form");
      if (this.form) {
        this.form.submit();
      }
    });
  }
}

customElements.define("custom-buy-button", customBuyButton);

class AnchorButton extends HTMLElement {
    constructor() {
        super(),
        this.init()
    }
    init() {
        this.addEventListener("click", event => {
            if (this.targetId = this.getAttribute("target-id"),
            this.targetId) {
                const targetItem = document.querySelector(this.targetId);
                event.preventDefault(),
                targetItem.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                })
            }
        }
        )
    }
}
customElements.define("anchor-button", AnchorButton);

function copyCpnCode(element) {
     const old_text = element.innerHTML;
         let cpnCode;
         if(element.dataset.text){
           cpnCode = element.dataset.text;
         }else{
           cpnCode = element.innerHTML;
         }
     navigator.clipboard.writeText(cpnCode.trim());

     element.innerHTML = "Copied";
     element.classList.add('discount-copied')
     setTimeout(function(){
       element.innerHTML = old_text;
       element.classList.remove('discount-copied')
     }, 4000);
}
